import { useRequest } from './request';

export interface HelpType {
  id: string;
  title: string;
  excerpt: string;
  description?: string;
}

export interface HelpTypes extends Array<HelpType> {}

export interface HelpNewState {
  ticket_id: string;
  type_id: string;
  description?: string;
}

export const HelpNewInitial = {
  ticket_id: "",
  type_id: "",
  description: "",
};

export interface UseHelpCancelState extends useRequest {}

export interface UseHelpCancelFields {
  ticket_id?: string;
}
